import { render } from "./GenerateAndActivate.vue?vue&type=template&id=5c85a035"
import script from "./GenerateAndActivate.vue?vue&type=script&lang=js"
export * from "./GenerateAndActivate.vue?vue&type=script&lang=js"

import "./GenerateAndActivate.vue?vue&type=style&index=0&id=5c85a035&lang=css"

import exportComponent from "/home/franck_boullier/Documents/bitbucket/exchange-app-admin-vue-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__